// ════════════════════════════════════════════════════════════════════════════════════════════════════════════
//  EL «?» DE LA CABECERA · CÓMO CONTACTAR CON BIANGO                                               (2-oct-2026)
// ════════════════════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño (2-oct): «podríamos poner en la app, arriba como un icono de ? que despliegue el correo de contacto a
//  biango, el número de teléfono 624665615, la web .es y las 2 apps con el icono de cada plataforma».
//
//  DÓNDE SALE: en la cabecera de la app de la CLÍNICA (components/Layout.jsx) y en la del panel de administración
//  (components/AdminLayout.jsx), junto a la campanita. En un móvil estrecho no cabe en la cabecera (B-050: el tema y
//  los modos ya pasaron al menú del avatar por lo mismo), así que va DENTRO del menú del avatar (`enMenu`). En el
//  panel de administración del móvil no hay menú del avatar: allí no se pinta. NO va en la app de los PACIENTES: un
//  paciente habla con su clínica, no con Biango.
//
//  LOS DATOS, de un solo sitio (`CONTACTO_BIANGO`): el correo es el del aviso legal de la web (web/contenido/sitio.js,
//  contacto.email), el teléfono el que dio el dueño, la web biango.es y las fichas de la app del equipo en las dos
//  tiendas, las mismas que la web (sitio.apps). Lo vigila backend/routes/web-tiendas-y-contacto.test.js.
//   · WHATSAPP (3-oct-2026): el dueño confirma que el número es también el WhatsApp de Biango, pero «ahora no hay
//     WhatsApp hasta que no haga lo de Meta». La fila «Escribir por WhatsApp» está preparada y sale SOLO cuando el
//     servidor la enciende (BIANGO_WHATSAPP_ACTIVO=1 en su .env; utils/whatsappBiango.js lo cuenta). Aquí sigue a null.
//   · LAS INSIGNIAS son las OFICIALES, sin tocar (frontend/public/assets/tiendas/): la de Apple, la de España («Consíguelo en
//     el App Store»), y la de Google en español. App Store primero, las dos con 40 px visibles de alto y su espacio
//     libre alrededor (el PNG de Google trae 29 de sus 250 px transparentes arriba y abajo: por eso mide 52).
//   · DENTRO DE LA APP NATIVA, SOLO LA DE SU TIENDA: la regla 2.3.10 de Apple no deja enseñar la tienda de otra
//     plataforma dentro de una app de iPhone, y en Android la de Apple no le sirve a nadie. En el navegador, las dos.
//
//  SIN HOOKS, A PROPÓSITO (como utils/espacioBarra.jsx): la cabecera la montan decenas de guardias con sus dobles, y
//  un `utils/` sin hooks se carga de verdad en todas sin tocar ninguna. El desplegable es un <details>: lo abre y lo
//  cierra el navegador (con el ratón y con el teclado, y el lector de pantalla dice si está abierto), y mientras está
//  abierto, `engancharCierre` lo cierra al pulsar o tocar fuera, al llevar el foco fuera, con Escape (que devuelve el
//  foco al «?») y al ir atrás o adelante. Es la misma regla que la campanita (components/CampanaAvisos.jsx): el panel
//  va FIJO y medido contra la ventana (B-684: colgado de la cabecera, un `overflow: hidden` lo cortaba).
//  Las guardias que pintan la cabecera con el React de verdad lo cargan con él: @pintarJsx-con-react
//  (test-helpers/pintarJsx.js, utilsJsxPropios).
//
//  EN EL MÓVIL «NO SE VE BIEN» (8-oct-2026, lista del dueño). Desplegado dentro del menú del avatar, el menú medía 200 px
//  de ancho (las insignias una encima de otra y «Abrir el centro de ayuda» partido en dos líneas) y crecía hacia abajo
//  sin tope: el contenedor de la app no se desplaza, así que lo de debajo (las insignias, la ayuda, Cerrar sesión y la
//  versión) quedaba fuera de la pantalla sin forma de bajar. Ahora el menú no pasa del alto visible y se desplaza por
//  dentro, en el móvil mide hasta 320 px (components/Layout.jsx, `data-menu-perfil`), la fila lleva su flecha, lo
//  desplegado va en su recuadro y, al abrirse, el menú baja solo hasta que se ve (`mostrarEnElMenu`). Dentro del menú,
//  tocar fuera NO lo cierra (`fuera: false`): para bajar por el menú hay que tocarlo, y eso lo cerraba.

import { whatsappBiango } from './whatsappBiango'
// t340 · con la función «asistente-lucia» (utils/luciaEnLaEsquina.jsx), el chat con el soporte se abre desde aquí: la esquina
// de abajo es de LucIA. Se lee como el menú lateral (sin hooks): utils/funcionesEstado no importa nada.
import { funcionEncendida } from './funcionesEstado'
// t353 · «Mostrar a LucIA», cuando se ha escondido con su X (utils/luciaEscondida, sin imports: se carga de verdad).
import { mostrarLucia } from './luciaEscondida'
// t369 · «Asistente LucIA» con su ATAJO DE TECLADO (Ctrl + Espacio; en un Mac, Opción + L): abre el asistente (utils/asistenteLucia,
// sin imports: se carga de verdad).
import { abrirAsistenteLucia, textoAtajoLucia, IMAGEN_LUCIA, RECORTE_CARA_LUCIA } from './asistenteLucia'
import { t as i18nT, marca, tDato } from './i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const CONTACTO_BIANGO = Object.freeze({
  correo: 'info@biango.es',
  telefono: '624 665 615',
  telefonoEnlace: 'tel:+34624665615',
  whatsapp: null,
  web: 'biango.es',
  webEnlace: 'https://biango.es',
  appStore: 'https://apps.apple.com/es/app/biango/id6815270076',
  googlePlay: 'https://play.google.com/store/apps/details?id=es.biango.dental',
})

export const INSIGNIAS = Object.freeze([
  { clave: 'appStore', tienda: marca('utils.contactoBiango.app_store', 'App Store'), src: '/assets/tiendas/insignia-app-store.svg', alt: marca('utils.contactoBiango.consiguelo_en_el_app_store', 'Consíguelo en el App Store'), ancho: 120, alto: 40, verse: 40, margen: '10px' },
  { clave: 'googlePlay', tienda: marca('utils.contactoBiango.google_play', 'Google Play'), src: '/assets/tiendas/insignia-google-play.png', alt: marca('utils.contactoBiango.disponible_en_google_play', 'Disponible en Google Play'), ancho: 646, alto: 250, verse: 52, margen: '4px 10px' },
])

// 'ios' | 'android' dentro de la app nativa (Capacitor); null en el navegador.
export function plataformaNativa(w) {
  try {
    const C = w && w.Capacitor
    if (C && typeof C.isNativePlatform === 'function' && C.isNativePlatform()) {
      const p = typeof C.getPlatform === 'function' ? C.getPlatform() : ''
      if (p === 'ios' || p === 'android') return p
    }
  } catch (_) { /* sin Capacitor: el navegador */ }
  return null
}

// Las insignias que se enseñan: en la app de iPhone, solo la de Apple; en la de Android, solo la de Google; en el
// navegador, las dos (Apple primero).
export function insigniasPara(plataforma) {
  if (plataforma === 'ios') return INSIGNIAS.filter((i) => i.clave === 'appStore')
  if (plataforma === 'android') return INSIGNIAS.filter((i) => i.clave === 'googlePlay')
  return INSIGNIAS.slice()
}

// Mientras está abierto: pulsar o tocar fuera, llevar el foco fuera, Escape o ir atrás/adelante lo cierran. Devuelve
// la función que quita los oyentes (también se quitan solos al cerrarse). Todo en CAPTURA: un `stopPropagation` de la
// pantalla no puede dejarlo abierto. Escape no sigue hacia los atajos de la pantalla y devuelve el foco al «?».
// `fuera: false` (dentro del menú del avatar): ni pulsar fuera ni el foco fuera lo cierran, solo Escape e ir atrás.
export function engancharCierre({ detalles, resumen, doc, win, recolocar, fuera = true }) {
  if (!detalles || !doc || typeof doc.addEventListener !== 'function') return () => {}
  let quitado = false
  const dentro = (t) => { try { return !!(t && detalles.contains && detalles.contains(t)) } catch (_) { return false } }
  const cerrar = (devolverFoco) => {
    quitar()
    if (detalles.open) detalles.open = false
    if (devolverFoco && resumen && typeof resumen.focus === 'function') { try { resumen.focus() } catch (_) { /* sin foco */ } }
  }
  const alPulsar = (e) => { if (!dentro(e && e.target)) cerrar(false) }
  const alFoco = (e) => { if (!dentro(e && e.target)) cerrar(false) }
  const alTeclear = (e) => {
    if (!e || e.key !== 'Escape') return
    if (typeof e.stopPropagation === 'function') e.stopPropagation()
    cerrar(true)
  }
  const alIr = () => cerrar(false)
  // Al cambiar el tamaño (girar el móvil, la barra de Safari que se esconde) se vuelve a medir, no se cierra.
  const alMedir = () => { if (typeof recolocar === 'function') recolocar() }
  function quitar() {
    if (quitado) return
    quitado = true
    if (fuera) {
      doc.removeEventListener('mousedown', alPulsar, true)
      doc.removeEventListener('touchstart', alPulsar, true)
      doc.removeEventListener('focusin', alFoco, true)
    }
    doc.removeEventListener('keydown', alTeclear, true)
    if (win && typeof win.removeEventListener === 'function') {
      win.removeEventListener('popstate', alIr)
      win.removeEventListener('resize', alMedir)
    }
  }
  if (fuera) {
    doc.addEventListener('mousedown', alPulsar, true)
    doc.addEventListener('touchstart', alPulsar, true)
    doc.addEventListener('focusin', alFoco, true)
  }
  doc.addEventListener('keydown', alTeclear, true)
  if (win && typeof win.addEventListener === 'function') {
    win.addEventListener('popstate', alIr)
    win.addEventListener('resize', alMedir)
  }
  return quitar
}

// El panel, FIJO y medido contra la ventana (la regla de la campanita, B-684), anclado por la derecha al «?». El
// tamaño del perfil es un zoom en <html> (B-868): lo medido va en px de pantalla y lo escrito se pinta multiplicado.
export function colocarPanel(detalles, w) {
  try {
    const resumen = detalles && detalles.querySelector && detalles.querySelector('summary')
    const panel = detalles && detalles.querySelector && detalles.querySelector('[data-contacto-panel]')
    if (!resumen || !panel || typeof resumen.getBoundingClientRect !== 'function' || !w) return null
    const z = zoomDeLaPagina()
    const r = resumen.getBoundingClientRect()
    const vw = (w.innerWidth || 0) / z
    const vh = (w.innerHeight || 0) / z
    const ancho = Math.min(340, Math.max(240, vw - 16))
    let der = Math.max(8, vw - r.right / z)
    if (der + ancho > vw - 8) der = Math.max(8, vw - ancho - 8)
    const arriba = r.bottom / z + 9
    const alto = Math.max(200, vh - arriba - 12)
    panel.style.top = arriba + 'px'
    panel.style.right = der + 'px'
    panel.style.width = ancho + 'px'
    panel.style.maxHeight = alto + 'px'
    return { arriba, der, ancho, alto }
  } catch (_) { return null }
}

// En el menú del avatar: al abrirse, que se vea. El menú se desplaza por dentro (Layout, `data-menu-perfil`); si lo
// desplegado acaba por debajo de lo visible, se sube hasta dejar «Contactar con Biango» arriba (o hasta el final del
// menú). La distancia se suma con offsetTop hasta el menú, en las mismas medidas que su scrollTop (con el zoom del
// perfil, B-868, getBoundingClientRect va en otras). Fuera de un menú así, o si ya se ve entero, no mueve nada.
export function mostrarEnElMenu(det) {
  try {
    const caja = det && typeof det.closest === 'function' ? det.closest('[data-menu-perfil]') : null
    if (!caja) return null
    let arriba = 0
    let n = det
    while (n && n !== caja) { arriba += n.offsetTop || 0; n = n.offsetParent }
    if (n !== caja) return null
    const alto = caja.clientHeight || 0
    if (arriba + (det.offsetHeight || 0) <= (caja.scrollTop || 0) + alto) return null
    const destino = Math.max(0, Math.min(arriba - 6, (caja.scrollHeight || 0) - alto))
    if (typeof caja.scrollTo === 'function') caja.scrollTo({ top: destino, behavior: 'smooth' })
    else caja.scrollTop = destino
    return destino
  } catch (_) { return null }
}

// B-868 · la misma de todas las pantallas (lo vigila routes/tamano-adaptativo.test.js §4). Sin import a propósito.
const zoomDeLaPagina = () => { try { return parseFloat(document.documentElement.style.zoom) || 1 } catch (_) { return 1 } }
const ventana = () => (typeof window !== 'undefined' ? window : null)
const documento = () => (typeof document !== 'undefined' ? document : null)

// ── Los iconos, de trazo, dibujados aquí (este fichero no importa nada: así lo cargan las guardias de la cabecera) ──
const Trazo = ({ d, s = 18 }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" style={{ flexShrink: 0 }}>
    <path d={d} />
  </svg>
)
const D_CORREO = 'M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM3.5 6.5l8.5 6.5 8.5-6.5'
const D_TELEFONO = 'M6.5 3.5h3l1.5 4-2 1.3a10.5 10.5 0 0 0 6.2 6.2l1.3-2 4 1.5v3a2 2 0 0 1-2 2A16 16 0 0 1 4.5 5.5a2 2 0 0 1 2-2z'
const D_CHAT = 'M20 11.5a8 8 0 0 1-11.7 7.1L4 19.5l1-4A8 8 0 1 1 20 11.5z'
const D_WEB = 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.5 2.7 3.6 5.7 3.6 9s-1.1 6.3-3.6 9c-2.5-2.7-3.6-5.7-3.6-9S9.5 5.7 12 3z'
const D_AYUDA = 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM9.6 9.3a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.1-2.4 3.6M12 17h.01'
const D_FLECHA = 'M9 6l6 6-6 6'

const estiloFila = {
  display: 'flex', alignItems: 'center', gap: '11px', padding: '9px 10px', borderRadius: '9px',
  color: 'var(--text-primary)', textDecoration: 'none', minWidth: 0,
}
const icoFila = { width: '32px', height: '32px', borderRadius: '9px', background: 'var(--surface-2)', border: '1px solid var(--border)', color: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }

function Fila({ href, d, que, valor, fuera, dato }) {
  return (
    <a href={href} data-contacto={dato} {...(fuera ? { target: '_blank', rel: 'noopener noreferrer' } : {})} style={estiloFila}>
      <span style={icoFila}><Trazo d={d} s={16} /></span>
      <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontSize: '11.5px', fontWeight: 700, color: 'var(--text-muted)' }}>{que}</span>
        <span style={{ fontSize: '14px', fontWeight: 700, overflowWrap: 'anywhere' }}>{valor}</span>
      </span>
    </a>
  )
}

/** El «?» y su desplegable. `enMenu`: la versión que va dentro del menú del avatar en el móvil (se abre en línea). */
export function ContactoBiango({ size = 32, radio = '50%', enMenu = false }) {
  const C = CONTACTO_BIANGO
  // El WhatsApp de Biango: solo si el servidor lo ha encendido (utils/whatsappBiango; null y la fila no sale).
  const wa = C.whatsapp || whatsappBiango()
  const insignias = insigniasPara(plataformaNativa(ventana()))

  // Se mide al pulsar, ANTES de que se abra: así sale ya en su sitio (medido después, se vería saltar).
  const alPulsarResumen = (e) => {
    const det = e && e.currentTarget && e.currentTarget.parentNode
    if (!enMenu && det && !det.open) colocarPanel(det, ventana())
  }
  const alAbrirOCerrar = (e) => {
    const det = e && e.currentTarget
    if (!det) return
    if (det.open) {
      if (det.__quitarCierre) det.__quitarCierre()
      det.__quitarCierre = engancharCierre({
        detalles: det,
        resumen: det.querySelector ? det.querySelector('summary') : null,
        doc: documento(),
        win: ventana(),
        recolocar: enMenu ? null : () => colocarPanel(det, ventana()),
        fuera: !enMenu,
      })
      if (enMenu) mostrarEnElMenu(det)
    } else if (det.__quitarCierre) {
      det.__quitarCierre()
      det.__quitarCierre = null
    }
  }
  // Al seguir un enlace del panel (correo, teléfono, web, tiendas) se cierra.
  const cerrarDesde = (e) => {
    const det = e && e.currentTarget && e.currentTarget.closest ? e.currentTarget.closest('details') : null
    if (det && det.open) det.open = false
  }
  const abrirAyuda = (e) => {
    cerrarDesde(e)
    try { window.dispatchEvent(new CustomEvent('abrir-ayuda')) } catch (_) { /* sin ventana */ }
  }
  // t340 · «Chat con el soporte»: el aviso lo atiende el globo (components/ChatWidget, utils/luciaEnLaEsquina · AVISO_ABRIR_SOPORTE).
  const conLucia = funcionEncendida('asistente-lucia')
  const abrirSoporte = (e) => {
    cerrarDesde(e)
    try { window.dispatchEvent(new CustomEvent('biango:abrir-soporte', { detail: { origen: 'interrogacion' } })) } catch (_) { /* sin ventana */ }
  }
  // t353 · la fila solo se ve con LucIA escondida (<html data-lucia-escondida>, la pone el globo; index.css): sin hooks.
  const sacarLucia = (e) => {
    cerrarDesde(e)
    mostrarLucia()
  }
  // t369 · abrir el asistente desde aquí, y su atajo dicho (en el menú del móvil no hay atajos: se dice qué es).
  const abrirLucia = (e) => {
    cerrarDesde(e)
    abrirAsistenteLucia()
  }
  const atajoLucia = textoAtajoLucia(typeof navigator !== 'undefined' ? navigator : null)

  const resumen = enMenu
    ? (
      <summary title={i18nT('utils.contactoBiango.contactar_con_biango', 'Contactar con Biango')} onClick={alPulsarResumen} style={{ listStyle: 'none', display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '8px', fontSize: '13px', color: 'var(--text-primary)', fontWeight: 500, cursor: 'pointer' }}>
        <Trazo d={D_AYUDA} s={16} /> <span style={{ flex: 1, minWidth: 0 }}>{i18nT('utils.contactoBiango.contactar_con_biango', 'Contactar con Biango')}</span>
        {/* La flecha dice que se despliega; gira al abrirse (index.css, details.contacto-biango[open]). */}
        <span data-contacto-flecha aria-hidden="true" style={{ display: 'inline-flex', color: 'var(--text-muted)' }}><Trazo d={D_FLECHA} s={14} /></span>
      </summary>
    )
    : (
      <summary aria-label={i18nT('utils.contactoBiango.contactar_con_biango', 'Contactar con Biango')} title={i18nT('utils.contactoBiango.contactar_con_biango', 'Contactar con Biango')} onClick={alPulsarResumen}
        style={{ listStyle: 'none', width: `${size}px`, height: `${size}px`, boxSizing: 'border-box', borderRadius: radio, border: '1px solid var(--border)', background: 'var(--surface-2)', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: `${Math.round(size * 0.47)}px`, fontWeight: 800, lineHeight: 1, userSelect: 'none' }}>
        <span aria-hidden="true">?</span>
      </summary>
    )

  const panel = (
    <div data-contacto-panel role="group" aria-label={i18nT('utils.contactoBiango.contacto_de_biango', 'Contacto de Biango')} onClick={(e) => { const a = e.target && e.target.closest ? e.target.closest('a') : null; if (a) cerrarDesde({ currentTarget: a }) }}
      style={enMenu
        ? { margin: '2px 0 6px', padding: '6px 2px 8px', display: 'flex', flexDirection: 'column', gap: '2px', border: '1px solid var(--border)', borderRadius: '10px', background: 'var(--surface)' }
        : { position: 'fixed', top: 'calc(env(safe-area-inset-top, 0px) + 66px)', right: '8px', width: 'min(340px, calc((100vw / var(--z, 1)) - 16px))', maxHeight: 'calc(var(--alto-pantalla) - 90px)', overflowY: 'auto', boxSizing: 'border-box', padding: '14px 12px 12px', display: 'flex', flexDirection: 'column', gap: '2px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', boxShadow: '0 18px 44px rgba(0,0,0,0.22)', zIndex: 2400, color: 'var(--text-primary)', textAlign: 'left' }}>
      {!enMenu && (
        <div style={{ padding: '0 10px 8px' }}>
          <div style={{ fontSize: '14.5px', fontWeight: 800 }}>{i18nT('utils.contactoBiango.contacta_con_biango', 'Contacta con Biango')}</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>{i18nT('utils.contactoBiango.dudas_sobre_el_programa_tu', 'Dudas sobre el programa, tu licencia o tu cuenta.')}</div>
        </div>
      )}
      {conLucia && (
        <button type="button" data-contacto="soporte" onClick={abrirSoporte}
          style={{ ...estiloFila, width: '100%', border: 'none', background: 'none', cursor: 'pointer', textAlign: 'left', font: 'inherit' }}>
          <span style={{ ...icoFila, position: 'relative' }}>
            <Trazo d={D_CHAT} s={16} />
            {/* El punto rojo: respuestas del soporte sin leer (lo enciende el globo en <html>, index.css). */}
            <span data-contacto-punto aria-hidden="true" />
          </span>
          <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '11.5px', fontWeight: 700, color: 'var(--text-muted)' }}>{i18nT('utils.contactoBiango.soporte_de_biango', 'Soporte de Biango')}</span>
            <span style={{ fontSize: '14px', fontWeight: 700 }}>{i18nT('utils.contactoBiango.chat_con_el_soporte', 'Chat con el soporte')}</span>
          </span>
        </button>
      )}
      {conLucia && (
        <button type="button" data-contacto="mostrar-lucia" onClick={sacarLucia}
          style={{ ...estiloFila, width: '100%', border: 'none', background: 'none', cursor: 'pointer', textAlign: 'left', font: 'inherit' }}>
          <span style={icoFila}><Trazo d={D_AYUDA} s={16} /></span>
          <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '11.5px', fontWeight: 700, color: 'var(--text-muted)' }}>{i18nT('utils.contactoBiango.la_has_escondido_con_su', 'La has escondido con su X')}</span>
            <span style={{ fontSize: '14px', fontWeight: 700 }}>{i18nT('utils.contactoBiango.mostrar_a_lucia', 'Mostrar a LucIA')}</span>
          </span>
        </button>
      )}
      {conLucia && (
        <button type="button" data-contacto="asistente-lucia" onClick={abrirLucia} title={i18nT('utils.contactoBiango.abrir_el_asistente_lucia', 'Abrir el asistente LucIA ({{atajoLucia}})', { atajoLucia })}
          style={{ ...estiloFila, width: '100%', border: 'none', background: 'none', cursor: 'pointer', textAlign: 'left', font: 'inherit' }}>
          <span aria-hidden="true" style={{ ...icoFila, position: 'relative', overflow: 'hidden', borderRadius: '50%' }}>
            <img src={IMAGEN_LUCIA} alt="" draggable="false" style={{ position: 'absolute', maxWidth: 'none', display: 'block', ...RECORTE_CARA_LUCIA }} />
          </span>
          <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: '11.5px', fontWeight: 700, color: 'var(--text-muted)' }}>{enMenu ? i18nT('utils.contactoBiango.tu_asistente_de_la_clinica', 'Tu asistente de la clínica') : i18nT('utils.contactoBiango.atajo', 'Atajo: {{atajoLucia}}', { atajoLucia })}</span>
            <span style={{ fontSize: '14px', fontWeight: 700 }}>{i18nT('utils.contactoBiango.asistente_lucia', 'Asistente LucIA')}</span>
          </span>
        </button>
      )}
      <Fila dato="correo" href={`mailto:${C.correo}`} d={D_CORREO} que={i18nT('utils.contactoBiango.correo', 'Correo')} valor={C.correo} />
      <Fila dato="telefono" href={C.telefonoEnlace} d={D_TELEFONO} que={i18nT('utils.contactoBiango.telefono', 'Teléfono')} valor={C.telefono} />
      {wa && <Fila dato="whatsapp" href={wa} d={D_CHAT} que="WhatsApp" valor={i18nT('utils.contactoBiango.escribir_por_whatsapp', 'Escribir por WhatsApp')} fuera />}
      <Fila dato="web" href={C.webEnlace} d={D_WEB} que={i18nT('utils.contactoBiango.web', 'Web')} valor={C.web} fuera />
      {insignias.length > 0 && (
        <div style={{ borderTop: '1px solid var(--border)', marginTop: '8px', padding: '10px 10px 0' }}>
          <div style={{ fontSize: '13px', fontWeight: 800 }}>{i18nT('utils.contactoBiango.la_app_de_biango', 'La app de Biango')}</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>{i18nT('utils.contactoBiango.para_tu_equipo_en_el', 'Para tu equipo, en el móvil. Entra con tu cuenta de siempre.')}</div>
          <div data-contacto-tiendas style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', margin: '0 -10px' }}>
            {insignias.map((i) => (
              <a key={i.clave} data-tienda={i.clave} href={C[i.clave]} target="_blank" rel="noopener noreferrer" aria-label={i18nT('utils.contactoBiango.la_app_biango', '{{alt}} (la app Biango)', { alt: tDato(i.alt) })} style={{ display: 'block', lineHeight: 0, borderRadius: '8px', flex: 'none' }}>
                <img src={i.src} alt={tDato(i.alt)} width={i.ancho} height={i.alto} style={{ display: 'block', height: `${i.verse}px`, width: 'auto', maxWidth: 'none', margin: i.margen }} />
              </a>
            ))}
          </div>
        </div>
      )}
      <button type="button" data-contacto="ayuda" onClick={abrirAyuda}
        style={{ marginTop: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '9px 10px', borderRadius: '9px', border: '1px solid var(--border)', background: 'var(--surface-2)', color: 'var(--primary)', fontSize: '12.5px', fontWeight: 700, cursor: 'pointer' }}>
        <Trazo d={D_AYUDA} s={15} />{i18nT('utils.contactoBiango.abrir_el_centro_de_ayuda', ' Abrir el centro de ayuda')}
      </button>
    </div>
  )

  return (
    <details className="contacto-biango" data-contacto-biango={enMenu ? 'menu' : 'cabecera'} onToggle={alAbrirOCerrar}
      style={enMenu ? { margin: 0 } : { position: 'relative', flexShrink: 0 }}>
      {/* Sin el triángulo de <summary>, el foco a la vista y las filas que se marcan: en index.css (details.contacto-biango). */}
      {/* El «?» mide antes de abrir: su `onClick` corre antes de que el navegador cambie `open`. */}
      {resumen}
      {panel}
    </details>
  )
}
